export default "__VITE_ASSET__UddRSIIS__";